import { BaseRequest } from './BaseRequest';

export class BotHealthPlansRequest extends BaseRequest {
}